import { PureComponent } from "react";
import classnames from "classnames";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";

import { inputStyle } from "./signup-with-text-component.scss";

export default class SignupWithTextComponent extends PureComponent {
  constructor(props) {
    super(props);
  }

  renderTexts() {
    const { title, subtitle } = this.props;
    return (
      <div className="signup-texts">
        {title && (
          <div className="signup-form-title">
            <h1>{title}</h1>
          </div>
        )}

        {subtitle && (
          <div className="signup-form-subtitle">
            <h2>{subtitle}</h2>
          </div>
        )}
      </div>
    );
  }

  renderForm() {
    return <SignupFormComponent {...this.props} />;
  }

  render() {
    const { subtitle, textUnderButtons } = this.props;

    return (
      <div
        className={classnames("signup-form-wrapper", {
          "with-subtitle": subtitle,
          "text-under-buttons": textUnderButtons
        })}
      >
        {textUnderButtons ? this.renderForm() : this.renderTexts()}
        {textUnderButtons ? this.renderTexts() : this.renderForm()}
        <style jsx>{inputStyle}</style>
      </div>
    );
  }
}

SignupWithTextComponent.defaultProps = {
  textUnderButtons: false
};
